<template>
<div>
   <div class="bg-white height-80 font-bold flex flex-space-around flex-wrap p20 fs-20 fc-828286">
     <div class="text-align-center margin-auto">实发金额</div>
     <div class="text-align-center margin-auto">￥{{ amount }}</div>
   </div>
   <div class="container mt-15 ">
    <div class="p10 fs-14 fc-828286 border-buttom" v-if="type !== '数据导入算薪'">
         <div class="wperenct30 text-align-left inline-block pl-10-wpercent">考勤时长</div>
         <div class="wperenct30 text-align-left inline-block pl-15-wpercent">{{ datetime }} 小时</div>
    </div>
    <div class="p10 fs-14 fc-828286 border-buttom" v-for="(item, index) in infoList" :key="index">
         <div class="wperenct30 text-align-left inline-block pl-10-wpercent">{{ formatList(item.label) }}</div>
         <div class="wperenct30 text-align-left inline-block pl-15-wpercent">￥{{ item.value }}</div>
    </div>
   </div>
</div>
</template>

<script>
import { getStmBatchEmployeeItemList } from '@/api/project/index';
export default {
  components: {
  },
  created() {
   this.getStmBatchEmployeeItemList(); // 获取list数据
   this.type = this.$route.query.ts;
  },
  data() {
    return {
      type: '',
      amount: 0, // 实发金额
      datetime: 0,
      infoList:[], // 列表数据
      sensitiveFontCode: ['工资', '薪酬', '薪水', '酬劳', '奖金', '薪资'], // 敏感的字符
    };
  },
  methods: {
    // 获取列表记录
    async getStmBatchEmployeeItemList() {
      const id = this.$route.query.c; // 取值路由的code 是用来查询用的id
      const { data } = await getStmBatchEmployeeItemList(id);
      this.amount = data.actPayAmount;
      const dataObj = data; // 转义
      /**
       * 以下是对列表对象的总工作时长进行操作
       * @param normalAttendanceHours 白班时长
       * @param nightAttendanceHours 夜班时长
       * @param workingdayOvertimeHours 工作日时长
       * @param weekendsOvertimeHours 周末双休加班时长
       * @param holidayOvertimeHours 法定假日时长
       */
      this.datetime = dataObj.normalAttendanceHours + dataObj.nightAttendanceHours + dataObj.workingdayOvertimeHours + dataObj.weekendsOvertimeHours + dataObj.holidayOvertimeHours;
      /**
       * 以下是格式化展示的字段 去除不必要的数据
       */
      let obj = [];
      const payrollData = JSON.parse(data.payrollData);
      // 展开所有子项中的 twoLevelTableColumn 字段 集合到一个新的对象中
      for(let i = 0; i < payrollData.length; i++) {
        // 如果没有twoLevelTableColumn就跳出来进行下一次循环，因为拿不到twoLevelTableColumn的长度会无法继续循环
        if(!payrollData[i].twoLevelTableColumn){
          continue;
        }
        // 不显示这两种类型的
        if(payrollData[i].label === '企业公积金缴费' || payrollData[i].label === '企业社保缴费'){
          continue;
        }
        // 进行内部第二次循环 拿出twoLevelTableColumn字段里面的子项 返回到新的对象push到展示list中
        for(let o = 0; o < payrollData[i].twoLevelTableColumn.length; o++) {
          obj.push((payrollData[i].twoLevelTableColumn)[o]);
        }
      }
      // 手动加一个对象 需要单独拼
      const elseData = [{
          label: '基本工资',
          value: 0,
        }]
        elseData[0].value = data.shouldPayAmount;
        elseData.push(...obj)
        if(this.type === '考勤时长算薪') {
          this.infoList = elseData; // 赋值
        } else {
          this.infoList = obj; // 常规赋值赋值
        }
      // shouldPayAmount
    },

    // 这里是薪酬、工资、等敏感字眼正则清除方法，传入字符串，返回一个转换完成的新字符串
      formatList(val) {
        let value = ''; // 转换结果
        for(let i = 0; i < this.sensitiveFontCode.length; i++){
        value = val.replace(this.sensitiveFontCode[i], '佣金');
        if(val.search(this.sensitiveFontCode[i]) !== -1){ // serach 的返回只有-1 和 2，-1表示符合了就跳出 不进行继续循环改变value的结果了。
          break;
        }
        }
      return value;
    }



  },
};
</script>

<style lang="less">
.border-buttom {
  border-bottom: #ceced6 1px solid;
}
</style>